import { IMRBaseComponent } from "../../../../../../../common/base"

import { OPERATOR_SECURITY_SERVICE_NAME } from "../../../../../../../../services/operator"
import { USER_SESSION_SERVICE_NAME } from "../../../../../../../../services/user-session"

import { OperatorDetailsSecurityEffectiveController } from "./operator-details.security.effective.controller"

//#region Asset Imports

import './operator-details.security.effective.scss'
import * as TEMPLATE from './operator-details.security.effective.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'operatorDetailsSecurityEffective'

export class OperatorDetailsSecurityEffectiveComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: OperatorDetailsSecurityEffectiveController,
            services: [OPERATOR_SECURITY_SERVICE_NAME, USER_SESSION_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}